export default {"src":"/_next/static/media/fingerprint.83a57957.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};